<template>
    <div class="w-full h-screen bg-white flex flex-col items-center justify-center">
        <p class="text-gray-600 text-lg">Logging out...</p>
    </div>
</template>

<script>
export default {
    name: "LogOut",
    metaInfo: {
      title: 'Logging Out',
    },
    async mounted () {
        try {
            await this.$auth.signOut();
            this.$router.push({ name: "Login" });
        } catch (e) {
            console.log(e);
        }
    }
}
</script>